module.exports = __webpack_public_path__ + "static/media/21.ea28bf60.jpg";